import { PageHero, SectionHeading, CTABand } from "../components/shared";
import { Reveal } from "../components/Reveal";
import { QHSE, CERTIFICATIONS, IMAGES } from "../data/content";
import { ShieldCheck } from "lucide-react";

const QhsePage = () => (
  <>
    <PageHero overline="Quality, Health, Safety & Environment" title="Safe, Responsible and Quality-Focused Execution" subtitle="Airanet aims to embed quality and safety into project planning, workforce mobilisation, site execution and reporting." image={IMAGES.ppe} />
    <section className="py-24 bg-white">
      <div className="max-w-[1360px] mx-auto px-5 md:px-8">
        <SectionHeading overline="Our Approach" title="Built Around People and Assets" sub="Employees and subcontractors are expected to comply with applicable client procedures, statutory requirements and site-specific safety controls." />
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {QHSE.map((q, i) => (
            <Reveal key={q} delay={(i % 3) * 0.06}>
              <div className="h-full bg-[#F4F6F8] border border-[#E2E8F0] rounded-lg p-6 hover:border-[#1EA7E1] transition-colors">
                <span className="grid place-items-center h-10 w-10 rounded-md bg-[#0B1F3A] text-[#1EA7E1]"><ShieldCheck className="h-5 w-5" /></span>
                <h3 className="mt-4 font-head font-semibold text-[#0B1F3A]">{q}</h3>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
    <section className="py-24 bg-[#F4F6F8]">
      <div className="max-w-[1360px] mx-auto px-5 md:px-8">
        <SectionHeading overline="Certifications & Registrations" title="Editable Placeholders" sub="No ISO certification or registration is claimed without supporting proof. These are shown for client approval." />
        <div className="mt-10 flex flex-wrap gap-3">
          {CERTIFICATIONS.map((c) => <span key={c} className="bg-white border border-[#E2E8F0] rounded-full px-4 py-2 text-sm text-[#252B33]">{c}</span>)}
        </div>
      </div>
    </section>
    <CTABand />
  </>
);

export default QhsePage;
